import React, { HTMLAttributes, useMemo } from 'react'
import { Loader } from '~components/Loader'
import * as Styled from './LoadingArea.styles'

interface CustomProps {
  /**
   * Has loading state?
   */
  isLoading: boolean
  /**
   * Placeholder contents
   */
  placeholder?: string
}

export type ComponentProps = CustomProps & HTMLAttributes<HTMLDivElement>

const LoadingArea: React.FC<ComponentProps> = ({ isLoading, placeholder = 'Loading...', children, ...divProps }) => {
  const loadingContent = useMemo(
    () => (
      <Styled.LoadingContent>
        <Loader size="large" />
        <Styled.Placeholder>{placeholder}</Styled.Placeholder>
      </Styled.LoadingContent>
    ),
    [placeholder],
  )

  return (
    <Styled.Container {...divProps}>
      {isLoading && loadingContent}
      <Styled.Content isShown={!isLoading}>{children}</Styled.Content>
    </Styled.Container>
  )
}

export default LoadingArea
